"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsEscalationPolicyTable = void 0;
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _react = _interopRequireWildcard(require("react"));
var _dmsbasereact = require("dmsbasereact");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DmsEscalationPolicyTable = () => {
  const table = (0, _react.useRef)(null);
  const header = [{
    label: _reactIntlUniversal.default.get("Name").d("Name"),
    column_name: "name",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Description").d("Description"),
    column_name: "description",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("IsActive").d("Is Active"),
    column_name: "is_active",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("AlertGroup").d("Alert Group"),
    column_name: "alert_group_pk",
    control: 'select',
    url: "/alert_group/all",
    filter: true
  }];
  return /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTable, {
    header: header,
    managed: true,
    needs_authentication: true,
    ref: table,
    url: "/escalation_policy/table",
    export_table: false,
    responsive: true
  });
};
exports.DmsEscalationPolicyTable = DmsEscalationPolicyTable;